export const ALL_PROVIDERS = "ALL_PROVIDERS";
export const ALL_PROVIDERS_EB = "ALL_PROVIDERS_EB";
export const ALL_PROVIDERS_SM = "ALL_PROVIDERS_SM";
export const ALL_PROVIDERS_KT = "ALL_PROVIDERS_KT";
export const ALL_PROVIDERS_SE = "ALL_PROVIDERS_SE";

export const ALL_EMAILS = "ALL_EMAILS";
export const ALL_EMAILS_COUNT = "ALL_EMAILS_COUNT";
